import { nodeComponentRegistry } from '../../../../r3f/NodeComponentRegistry';
import { AreaLight3D } from './Component';
nodeComponentRegistry.register({ typeName: 'AreaLight3D', Component: AreaLight3D });
//# sourceMappingURL=index.r3f.js.map